// extracted by mini-css-extract-plugin
module.exports = {"btnBackDiv":"Back__btnBackDiv__14TQ8"};